import { type ReactNode } from "react";
import { useCanAccess } from "ra-core";
import { ShieldAlert, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";

interface AdminOnlyRouteProps {
  children: ReactNode;
  resource?: string;
}

export const AdminOnlyRoute = ({
  children,
  resource = "configuration",
}: AdminOnlyRouteProps) => {
  const { canAccess, isPending } = useCanAccess({
    resource,
    action: "list",
  });

  if (isPending) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!canAccess) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[70vh] p-6 text-center animate-in fade-in-50 duration-300">
        <div className="w-16 h-16 rounded-2xl bg-destructive/10 text-destructive flex items-center justify-center mb-4 shadow-xs">
          <ShieldAlert className="w-8 h-8" />
        </div>
        <h2 className="text-xl font-bold tracking-tight text-foreground mb-2">
          Acesso Restrito
        </h2>
        <p className="text-sm text-muted-foreground max-w-md mb-6 leading-relaxed">
          Esta área é restrita a administradores do sistema. Seu nível de acesso
          atual não possui permissão para visualizar ou alterar estas
          configurações.
        </p>
        <div className="flex items-center gap-3">
          <Button variant="default" asChild className="gap-2">
            <Link to="/deals">
              <ArrowLeft className="w-4 h-4" />
              Voltar aos Negócios
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/">Dashboard</Link>
          </Button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
